angular.module('TetherApp').factory('clientUpdateService', [
    '$http',
    function($http) {
        let setSelectedClient = function (data, successCallback) {
            return $http.post('/home/client', {client: data, redirect: false},
                {
                    cache: false,
                    headers: { 'Cache-control': 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        successCallback();
                        return response.data
                    }
                );
        };
        return {
            setSelectedClient: setSelectedClient
        }
    }
]);
